import { render, staticRenderFns } from "./TabBarLayout.vue?vue&type=template&id=29a3994a&scoped=true&"
import script from "./TabBarLayout.vue?vue&type=script&lang=js&"
export * from "./TabBarLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabBarLayout.vue?vue&type=style&index=0&id=29a3994a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3994a",
  null
  
)

export default component.exports